export default {
  // 共通
  QUESTIONNAIRE_REQUEST_TITLE: "问卷请求",
  QUESTIONNAIRE_REQUEST_DESCRIPTION: "为了提升服务质量，我们决定进行问卷调查。若您能协助我们，我们将不胜感激。",
  QUESTIONNAIRE_TEXT_AREA_PLACEHOLDER: "如果您选择了“其他”，请在此处填写详细信息。",
  SEND_QUESTIONNAIRE: "提交调查问卷",
};
